import mapboxgl from "mapbox-gl";
export { mapboxgl };
export var GeoJSONEnums;
(function (GeoJSONEnums) {
    GeoJSONEnums["fetched"] = "fetched";
    GeoJSONEnums["added"] = "added";
    GeoJSONEnums["temporary"] = "temporary";
})(GeoJSONEnums || (GeoJSONEnums = {}));
export var CUEvents;
(function (CUEvents) {
    CUEvents["geoJSONLoaded"] = "geoJSONLoaded";
    CUEvents["serverDataError"] = "serverDataError";
    CUEvents["campusKeysFetchError"] = "campusKeysFetchError";
    CUEvents["campusKeysError"] = "campusKeysError";
    CUEvents["geoJSONFetchError"] = "geoJSONFetchError";
    CUEvents["customStylesFetchError"] = "customStylesFetchError";
    CUEvents["geoJSONError"] = "geoJSONError";
    CUEvents["piDataLoaded"] = "piDataLoaded";
    CUEvents["campusChange"] = "campusChange";
    CUEvents["roomHover"] = "roomHover";
    CUEvents["roomClick"] = "roomClick";
    CUEvents["buildingClick"] = "buildingClick";
    CUEvents["buildingHover"] = "buildingHover";
    CUEvents["layersSourcesInitialized"] = "layersSourcesInitialized,";
    CUEvents["customStylingValuesLoaded"] = "customStylingValuesLoaded";
})(CUEvents || (CUEvents = {}));
